var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "printfieldWrapper"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "1px 0px",
      "border-bottom": "1px solid rgb(173, 180, 187)",
      "box-shadow": "rgb(243, 253, 255) 0px 1px 0px"
    }
  }, [_c('label', {
    staticStyle: {
      "padding-top": "8px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('advanced printing')))])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills f-s"
  }, [(_vm.activeData) ? _c('li', {
    staticClass: "active",
    staticStyle: {
      "float": "none",
      "width": "100%",
      "padding": "5px 16px 0px 16px"
    }
  }, [_c('a', {
    staticClass: "f-s-a",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.activeData.father.des))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "well",
    staticStyle: {
      "margin": "15px",
      "padding": "5px 19px 15px 19px"
    }
  }, [_c('form', {
    staticClass: "search-form row"
  }, [_c('div', {
    staticStyle: {
      "box-shadow": "rgb(80, 94, 101) 0px 1px 0px"
    }
  }, [_c('label', {
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('include')))])]), _vm._v(" "), _vm._l((_vm.includes), function(value, prop) {
    return (_vm.visible[prop]) ? _c('input-w', {
      key: prop,
      attrs: {
        "configs": {
          "id": prop + "Check"
        }
      },
      model: {
        value: (_vm.includes[prop]),
        callback: function($$v) {
          _vm.$set(_vm.includes, prop, $$v)
        },
        expression: "includes[prop]"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.includes[prop]),
        expression: "includes[prop]"
      }],
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "disabled": (prop == 'discendenti' && _vm.disableTree) || (prop == 'discendenti' && _vm.noNephews) || (prop == 'indice' && _vm.noNephews),
        "id": prop,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.includes[prop]) ? _vm._i(_vm.includes[prop], null) > -1 : (_vm.includes[prop])
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.includes[prop],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.includes[prop] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.includes[prop] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.includes, prop, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "reduce",
      attrs: {
        "for": prop
      }
    }, [_vm._v(_vm._s(_vm.labels[prop]))])]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.optionsList.length > 0) ? _c('form', {
    staticClass: "search-form row"
  }, [_c('div', {
    staticStyle: {
      "box-shadow": "rgb(80, 94, 101) 0px 1px 0px"
    }
  }, [_c('label', {
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('printing options')))])]), _vm._v(" "), _vm._l((_vm.options), function(value, prop) {
    return (_vm.visible[prop]) ? _c('input-w', {
      key: prop,
      attrs: {
        "configs": {
          "id": prop + "Check"
        }
      },
      model: {
        value: (_vm.options[prop]),
        callback: function($$v) {
          _vm.$set(_vm.options, prop, $$v)
        },
        expression: "options[prop]"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.options[prop]),
        expression: "options[prop]"
      }],
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "disabled": prop == 'fr' && _vm.noNephews,
        "id": prop,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.options[prop]) ? _vm._i(_vm.options[prop], null) > -1 : (_vm.options[prop])
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.options[prop],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.options[prop] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.options[prop] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.options, prop, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "reduce",
      attrs: {
        "for": prop
      }
    }, [_vm._v(_vm._s(_vm.labels[prop]))])]) : _vm._e()
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "capPrint"
    }
  }, [_c('dynButton', {
    attrs: {
      "configs": {
        ID: 'buttons.print',
        visible: true
      },
      "icon": _vm.$root.icons.print,
      "btnClasses": "btn-primary",
      "exec": _vm.sendPrintRequest,
      "styleObj": {
        'z-index': '999',
        'width': '50%',
        'height': '26px'
      }
    }
  })], 1), _vm._v(" "), (_vm.showWarning) ? _c('div', {
    staticClass: "panel panel-warning",
    staticStyle: {
      "margin": "12px",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.translateWarning(_vm.warning)) + "\n            "), (_vm.showAvailables) ? _c('div', {
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.printableList.join(', ')))]) : _vm._e()])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-452fc899","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu-sup-components/Stampa.vue
// module id = 1451
// module chunks = 1